import { useTranslation } from "@opendash/core";
import { Flex, Typography } from "antd";
import { observer } from "mobx-react-lite";
import React from "react";
import { TicketManager } from "..";
import { KanbanStateSelect } from "../..";
import { SourceSelect } from "../../../../_shared";
import { IssueSelect } from "../../issue/components/IssueSelect";

type Props = {
  ticketManager: TicketManager;
  refetch?: () => void;
};

export const TicketFilterSelect = observer((props: Props) => {
  const t = useTranslation();

  return (
    <Flex vertical gap={16}>
      <Flex vertical>
        <Typography.Text>
          {t(`maintenance:settings.filterby.issuecategory.label`)}
        </Typography.Text>
        <IssueSelect
          onChange={(value) => {
            if (!value) props.ticketManager.removeFilter("issuecategory");
            else
              props.ticketManager.addFilter("issuecategory", {
                attribute: "issuecategory",
                value: value,
              });
            props.refetch?.();
          }}
          value={props.ticketManager.getFilter("issuecategory")?.value}
        />
      </Flex>
      <Flex vertical>
        <Typography.Text>
          {t(`maintenance:settings.filterby.status.label`)}
        </Typography.Text>
        <KanbanStateSelect
          value={props.ticketManager.getFilter("state")?.value}
          onChange={(value) => {
            if (!value) props.ticketManager.removeFilter("state");
            else
              props.ticketManager.addFilter("state", {
                attribute: "state",
                value: value.toString(),
              });

            props.refetch?.();
          }}
          allowClear
        />
      </Flex>
      <Flex vertical>
        <Typography.Text>
          {t(`maintenance:settings.filterby.source.label`)}
        </Typography.Text>
        <SourceSelect
          value={props.ticketManager.getFilter("source")?.value}
          onChange={(value) => {
            if (!value) props.ticketManager.removeFilter("source");
            else
              props.ticketManager.addFilter("source", {
                attribute: "source",
                value: value,
              });
            props.refetch?.();
          }}
        />
      </Flex>
    </Flex>
  );
});
